<template>
	<modal centered="true" :showing="showing" @closed="$emit('cancelled')" name="confirmDelete">
		<h5 class="t-text-black t-font-bold" slot="title">
			{{ title }}
		</h5>
		<div class="t-flex t-items-center t-justify-start t-px-4 t-py-3">
			{{ text }}
		</div>
		<div class="t-flex t-items-center t-justify-end t-py-4">
			<button type="button" class="t-bg-gray-500 hover:t-bg-gray-700 t-text-white t-font-bold t-py-2 t-px-4 t-mx-2 t-rounded focus:t-outline-none focus:t-shadow-outline" @click="$emit('cancelled')">
				Cancel
			</button>
			<button v-if="deleting" disabled class="t-bg-red-500 hover:t-bg-red-700 t-text-white t-font-bold t-py-2 t-px-4 t-mx-2 t-rounded focus:t-outline-none focus:t-shadow-outline">
				<i class="fa fa-spinner fa-spin"></i>
			</button>
			<button v-else type="button" class="t-bg-red-500 hover:t-bg-red-700 t-text-white t-font-bold t-py-2 t-px-4 t-mx-2 t-rounded focus:t-outline-none focus:t-shadow-outline" @click="$emit('confirmed')">
				Delete
			</button>
		</div>
	</modal>
</template>

<script>
	import Modal from './Modal';

    export default {
        name: 'confirm-delete',

		props: {
			'title': {
				default: "Confirm delete?",
				type: String
			},
			'text': {
				default: "Are you sure you want to delete this?",
				type: String
			},
			'deleting': {
				default: false,
				type: Boolean
			},
			'showing': {
				default: false,
				type: Boolean
			}
		},

		components: { Modal },

		mounted() {
			let that = this;
			
			document.addEventListener('keydown', function(event) {
				if (event.keyCode === 13) {
					that.$emit('confirmed')
				}
			});
		}
	}

</script>